import {
  components,
} from '@/generated/qmulus/openapi.ts';
import {
  EAppGroupSemantic,
} from '@/types/app-type.ts';
import {
  TAssetTypes,
} from '@/types/asset-type.ts';
import {
  TModuleType,
} from '@/types/company-type.ts';
import {
  EAppId,
} from '@/types/qmulus-app-type.ts';

const AppGroupSemantic: Record<EAppGroupSemantic, string> = {
  [EAppGroupSemantic.SALES]: 'Sales',
  [EAppGroupSemantic.CONFIGURATION]: 'Configuration',
  [EAppGroupSemantic.DEVELOPMENT]: 'Development',
};

const AppSemanticGroupId: Record<components['schemas']['QmulusOperationSemanticAppGroup']['appIds'][number], string> = {
  LICENSE: 'Licence issuer',
  PRICING_CALCULATOR: 'Pricing Calculator',
  PRICING_CALCULATOR_SETTINGS: 'Settings',
  USER_MANAGEMENT: 'User Management',
};

const AppAssetTypes: Record<TAssetTypes, string> = {
  TYPE_I: 'TYPE I',
  TYPE_II: 'TYPE II',
  TYPE_III: 'TYPE III',
  CARS: 'CARS',
  MAGAZINES: 'MAGAZINES',
  T_LINES: 'T-LINES',
  AUTOMAT_I: 'AUTOMAT I',
  AUTOMAT_II: 'AUTOMAT II',
  AUTOMAT_III: 'AUTOMAT III',
};

const AppModuleTypes: Record<TModuleType, string> = {
  QMULUS_ESSENTIAL: 'Essential',
  QMULUS_LITE: 'Lite',
  SETTINGS: 'Settings',
  QMULUS_EXPERT: 'Expert',
  SIMULATORS: 'Simulators',
  QMULUS_OPERATIONS: 'Operations',
  QMULUS_PERFORMANCE: 'Perfomance',
  QMULUS_AI: 'AI',
  QMULUS_ANALYTICS: 'Analytics',
  QMULUS_AUDIT: 'Audit',
  QMULUS_QUALITY: 'Quality',
  QMULUS_PLANNER: 'Planner',
  QMULUS_TOOLING_AND_GAUGE_MANAGER: 'Tooling and Gauge Manager',
  QMULUS_AUTOMATION: 'Automation',
};

const AppId: Record<EAppId, string> = {
  [EAppId.AI_ASSISTANT]: 'AI Assistant',
  [EAppId.ALARM_STATISTICS]: 'Alarm Statistics',
  [EAppId.ANOMALY_DETECTION]: 'Anomaly Detection',
  [EAppId.ASSET_MANAGEMENT]: 'Asset Management',
  [EAppId.CERTIFICATION]: 'Audit & Quality',
  [EAppId.CUSTOMER]: 'Customer',
  [EAppId.DEPRECATED_MODEL_PROCESS]: 'Model Process Builder',
  [EAppId.GRAFANA]: 'Grafana',
  [EAppId.HISTORY_AND_TRENDS]: 'History and Trends',
  [EAppId.LIVE]: 'Live app',
  [EAppId.MATERIALS]: 'Materials',
  [EAppId.MODEL_BUILDER]: 'Model Builder',
  [EAppId.OPERATION_CALENDAR]: 'Operation Calendar',
  [EAppId.ORDERS]: 'Orders',
  [EAppId.PARTS]: 'Parts',
  [EAppId.PERFORMANCE_DASHBOARD]: 'Performance Dashboard',
  [EAppId.PRODUCTION_LOGS]: 'Production Logs',
  [EAppId.PRODUCTION_SCHEDULER]: 'Production Scheduler',
  [EAppId.PRODUCTION_STATISTICS]: 'Production Statistics',
  [EAppId.PT9800_CONFIGURATION]: 'Protherm Configuration',
  [EAppId.QMULUS_DASHBOARD]: 'Dashboards',
  [EAppId.RECIPE]: 'Recipes',
  [EAppId.RECIPE_ON_DEMAND]: 'Recipe on Demand',
  [EAppId.REMOTE_CONTROL]: 'Remote Control',
  [EAppId.SHOP_LAYOUT]: 'Shop Layout',
  [EAppId.SIMULATOR]: 'Simulators',
  [EAppId.TENANT_SETTINGS]: 'Settings',
  [EAppId.UPC_PRO]: 'UPC Toolbox',
  [EAppId.USER_MANAGEMENT]: 'User Management',
};

export default {
  AppId,
  AppAssetTypes,
  AppModuleTypes,
  AppGroupSemantic,
  AppSemanticGroupId,
};
